/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography, breakpoints } from '@coursera/cds-core';

import type { EntWebsiteH1H2CtaFragment } from 'bundles/ent-website/__generated__/contentfulTypes';

const styles = {
  heading: () => css`
    font-size: 64px;
    font-weight: 600;
    letter-spacing: -1.92px;
    margin-bottom: 16px;
    line-height: 100%;
    ${breakpoints.down('sm')} {
      font-size: 40px;
      letter-spacing: -1.2px;
    }
  `,
  subheading: () => css`
    font-size: 24px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.48px;

    ${breakpoints.down('sm')} {
      font-size: 18px;
      letter-spacing: -0.54px;
    }
  `,
};

export const EntWebsiteH1H2Cta = ({ content }: { content: EntWebsiteH1H2CtaFragment }) => {
  if (!content) {
    return null;
  }

  return (
    <Grid container direction="column">
      {content?.heading && (
        <Typography variant="d1semibold" css={styles.heading}>
          {content?.heading}
        </Typography>
      )}
      {content?.subheading && (
        <Typography variant="h2" css={styles.subheading}>
          {content?.subheading}
        </Typography>
      )}
    </Grid>
  );
};

export default React.memo(EntWebsiteH1H2Cta);
